import { cn } from '@/lib/utils'
import { Link } from 'react-router'

type Props = {
  readonly path: string
  readonly label: string
  readonly description?: string
  readonly isActive: boolean
  readonly variant: 'desktop' | 'mobile'
  readonly onClick?: () => void
}

export function NavSubmenuItem({ path, label, description, isActive, variant, onClick }: Props) {
  if (variant === 'desktop') {
    return (
      <li>
        <Link
          to={path}
          onClick={onClick}
          aria-current={isActive ? 'page' : undefined}
          className={cn(
            'group/item block rounded-md px-4 py-3 transition-colors hover:bg-[#252b45]',
            isActive ? 'bg-[#252b45]' : ''
          )}
        >
          <div className='mb-1 text-base font-semibold text-white'>{label}</div>
          {description && <div className='text-sm text-[#ddd] group-hover/item:text-[#fff]'>{description}</div>}
        </Link>
      </li>
    )
  }

  return (
    <li>
      <Link
        to={path}
        onClick={onClick}
        aria-current={isActive ? 'page' : undefined}
        className={cn(
          'block rounded-md px-3 py-2 text-sm font-medium transition-colors',
          isActive ? 'bg-blue-50 text-[#0e2c89]' : 'text-gray-600 hover:bg-gray-50 hover:text-[#0e2c89]'
        )}
      >
        {label}
      </Link>
    </li>
  )
}
